export const transformPromoCode = (item) => ({
    id: item.id,
    promo_code: item.promoCode ?? item.promo_code,
    description: item.description,
    products: item.products ?? [],
    product_requirement: item.productRequirement ?? item.product_requirement,
    required_quantity: item.requiredQuantity ?? item.required_quantity,
    discount_amount: item.discountAmount ?? item.discount_amount,
    discount_type: item.discountType ?? item.discount_type,
    start_date: item.startDate ?? item.start_date,
    end_date: item.endDate ?? item.end_date,
    usage_limit: item.usageLimit ?? item.usage_limit,
    usage_count: item.usageCount ?? item.usage_count,
    is_single_use_per_customer: item.isSingleUsePerCustomer ?? item.is_single_use_per_customer,
    can_be_used: item.canBeUsed ?? item.can_be_used,
    is_valid_date_range: item.isValidDateRange ?? item.is_valid_date_range,
    is_usage_available: item.isUsageAvailable ?? item.is_usage_available,
    is_active: item.isActive ?? item.is_active,
    created_at: item.createdAt ?? item.created_at,
    updated_at: item.updatedAt ?? item.updated_at,
});
export const prepareApiData = (data) => ({
    promoCode: data.promo_code,
    description: data.description || '',
    isActive: data.is_active !== undefined ? data.is_active : true,
    productRequirement: data.product_requirement || 'any',
    requiredQuantity: data.required_quantity || 1,
    discountAmount: data.discount_amount,
    discountType: data.discount_type || 'flat',
    startDate: data.start_date ? new Date(data.start_date).toISOString() : null,
    endDate: data.end_date ? new Date(data.end_date).toISOString() : null,
    usageLimit: data.usage_limit !== undefined && data.usage_limit !== null ? data.usage_limit : null,
    isSingleUsePerCustomer: data.is_single_use_per_customer !== undefined ? data.is_single_use_per_customer : true,
});
